import { render, staticRenderFns } from "./status.vue?vue&type=template&id=d871163e&scoped=true"
import script from "./status.vue?vue&type=script&lang=js"
export * from "./status.vue?vue&type=script&lang=js"
import style0 from "./status.vue?vue&type=style&index=0&id=d871163e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d871163e",
  null
  
)

export default component.exports